import { render, staticRenderFns } from "./myTitle.vue?vue&type=template&id=16b2126e&scoped=true"
import script from "./myTitle.vue?vue&type=script&lang=js"
export * from "./myTitle.vue?vue&type=script&lang=js"
import style0 from "./myTitle.vue?vue&type=style&index=0&id=16b2126e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b2126e",
  null
  
)

export default component.exports